<rt-dialog-body layout-vertical>
  <div class="toolbar" layout-horizontal layout-space-between>
    <div class="heading-wrap" layout-vertical margin-right-small-x>
      <rt-heading variant="heading large-x" margin-bottom-small-x padding-top-small-xx>
        <rt-truncate min-width-0 margin-top-small-xxx>{{
          attachment.filename || header
        }}</rt-truncate>
      </rt-heading>
      <rt-date variant="left-align" [time]="attachment.createdAt" />
    </div>
    <a
      rt-button
      [href]="
        !!attachment.originalFileUrl?.length ? attachment.originalFileUrl : attachment.fileUrl
      "
      [download]="newDownloadedFileName || ''"
      target="_blank"
      variant="tertiary"
    >
      <rt-icon name="file-download" />
      <span>{{ translations.downloadFile | translate }}</span>
    </a>
  </div>

  <div class="viewer-content" margin-tb-large layout-horizontal layout-justify-center>
    <div>
      @if (isImage) {
        <img class="image" [src]="attachment.imageUrl" />
      }
    </div>
    @if (isPdf) {
      <rt-pdf-viewer [assetUrl]="pdfUrl!" />
    }
  </div>
</rt-dialog-body>
